export const DATASOURCE_METRICS_VALUE_PC_DETAILS = [
  ['steam', 'pcu'],
  ['steam', 'acu'],
  ['Mscience', 'digitalRevenue'],
  ['Mscience', 'units'],
  ['Mscience', 'ast'],
  ['npd', 'revenue'],
  ['newzoo', 'mau'],
  ['newzoo', 'player_share'],
  ['newzoo', 'mau_growth'],
  ['newzoo', 'mau_new'],
  ['newzoo', 'mau_returning'],
  ['newzoo', 'lifetime_player'],
  ['newzoo', 'time_spent_0H'],
  ['newzoo', 'time_spent_1H'],
  ['newzoo', 'time_spent_5H'],
  ['newzoo', 'time_spent_10H'],
  ['newzoo', 'time_spent_25H'],
  ['newzoo', 'time_spent_50H'],
  ['newzoo', 'avg_daily_playtime'],
  ['newzoo', 'avg_daily_sessions'],
  ['newzoo', 'avg_playtime_per_session'],
  ['newzoo', 'avg_monthly_playtime'],
  ['newzoo', 'avg_monthly_sessions'],
  ['newzoo', 'avg_days_played'],
  ['newzoo', 'stickiness'],
  ['newzoo', 'total_hours'],
  ['newzoo', 'churn'],
  ['newzoo', 'acquisition'],
  ['newzoo', 'retention_d1'],
  ['newzoo', 'retention_d2'],
  ['newzoo', 'retention_d4'],
  ['newzoo', 'retention_d7'],
  ['newzoo', 'retention_d14'],
  ['newzoo', 'retention_d28'],
  ['stream', 'hoursWatched'],
  ['stream', 'airtime'],
  ['stream', 'peackCCV'],
  ['stream', 'avgCCV'],
  ['vginsights', 'est_revenue'],
  ['vginsights', 'est_cumulative_revenue'],
  ['vginsights', 'est_units'],
  ['vginsights', 'est_cumulative_units'],
  ['vginsights', 'est_price'],
  ['vginsights', 'weighted_price'],
  ['vginsights', 'lifetime_weighted_price'],
  ['vginsights', 'players_by_country'],
  ['vginsights', 'playtime'],
  ['vginsights', 'followers'],
];

export const DATASOURCE_METRICS_VALUE_CONSOLE_DETAILS_COMMON = [
  ['Mscience', 'digitalRevenue'],
  ['Mscience', 'units'],
  ['Mscience', 'ast'],
  ['npd', 'revenue'],
  ['newzoo', 'mau'],
  ['newzoo', 'player_share'],
  ['newzoo', 'mau_growth'],
  ['newzoo', 'mau_new'],
  ['newzoo', 'mau_returning'],
  ['newzoo', 'lifetime_player'],
  ['newzoo', 'time_spent_0H'],
  ['newzoo', 'time_spent_1H'],
  ['newzoo', 'time_spent_5H'],
  ['newzoo', 'time_spent_10H'],
  ['newzoo', 'time_spent_25H'],
  ['newzoo', 'time_spent_50H'],
  ['newzoo', 'avg_daily_playtime'],
  ['newzoo', 'avg_daily_sessions'],
  ['newzoo', 'avg_playtime_per_session'],
  ['newzoo', 'avg_monthly_playtime'],
  ['newzoo', 'avg_monthly_sessions'],
  ['newzoo', 'avg_days_played'],
  ['newzoo', 'stickiness'],
  ['newzoo', 'total_hours'],
  ['newzoo', 'churn'],
  ['newzoo', 'acquisition'],
  ['newzoo', 'retention_d1'],
  ['newzoo', 'retention_d2'],
  ['newzoo', 'retention_d4'],
  ['newzoo', 'retention_d7'],
  ['newzoo', 'retention_d14'],
  ['newzoo', 'retention_d28'],
  ['stream', 'hoursWatched'],
  ['stream', 'airtime'],
  ['stream', 'peackCCV'],
  ['stream', 'avgCCV'],
];

export const DATASOURCE_METRICS_VALUE_CONSOLE_DETAILS_FAMITSU = [
  // Famitsu is temporarily unavailable in Intelligence pages.
  // ['famitsu', 'week_sales'],
  // ['famitsu', 'revenue'],
  // ['famitsu', 'total_sales'],
  // ['famitsu', 'total_revenue'],
  // ['famitsu', 'usd_price'],
];

// console游戏详情页下载 指标配置
export const DATASOURCE_METRICS_VALUE_CONSOLE_DETAILS = [
  ...DATASOURCE_METRICS_VALUE_CONSOLE_DETAILS_COMMON,
  // Famitsu is temporarily unavailable in Intelligence pages.
  // ...DATASOURCE_METRICS_VALUE_CONSOLE_DETAILS_FAMITSU,
];

export const DEVICE_DETAIL_DISABLED_MESSAGE = 'Only set for Corresponding data source.';

export const DEVICES_DETAIL_MAP: {
  [key: string]: any[];
} = {
  digitalrevenue: [
    {
      label: 'PlayStation',
      value: 'PlayStation',
      disabled: false,
      disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
    },
    {
      label: 'Xbox',
      value: 'Xbox',
      disabled: false,
      disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
    },
    {
      label: 'Nintendo',
      value: 'Nintendo',
      disabled: false,
      disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
    },
  ],
  physicalrevenue: [
    {
      value: 'PlayStation 4',
      label: 'PlayStation 4',
      disabled: false,
      disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
    },
    {
      value: 'PlayStation 5',
      label: 'PlayStation 5',
      disabled: false,
      disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
    },
    {
      value: 'Xbox One',
      label: 'Xbox One',
      disabled: false,
      disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
    },
    {
      value: 'Xbox Series X|S',
      label: 'Xbox Series X|S',
      disabled: false,
      disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
    },
    {
      value: 'Nintendo Wii U',
      label: 'Wii U',
      disabled: false,
      disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
    },
    {
      value: 'Nintendo Switch',
      label: 'Switch',
      disabled: false,
      disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
    },
  ],
  japansales: [
    {
      value: 'ps5',
      label: 'PS5',
      disabled: false,
      disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
    },
    {
      value: 'ps4',
      label: 'PS4',
      disabled: false,
      disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
    },
    {
      value: 'switch',
      label: 'Switch',
      disabled: false,
      disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
    },
  ],
};

// company详情页下载 指标配置
export const DATASOURCE_METRICS_COMPANY_DETAILS = [
  {
    text: 'Mobile Metrics',
    value: 'Mobile Metrics',
    disabled: false,
    isNoIcon: true,
    children: [
      { text: 'Mobile Revenue', value: 'mobile_revenue', icon: 'sensortower' },
      { text: 'Mobile Download', value: 'mobile_download', icon: 'sensortower' },
    ],
  },
  {
    text: 'PC Metrics',
    value: 'PC Metrics',
    disabled: false,
    isNoIcon: true,
    children: [
      { text: 'PC Digital Revenue', value: 'pc_digitalRevenue', icon: 'Mscience' },
      { text: 'PC Physical Revenue', value: 'pc_physicalRevenue', icon: 'npd' },
      { text: 'PC Steam PCU', value: 'pc_pcu', icon: 'steam' },
      { text: 'PC MAU', value: 'pc_mau', icon: 'newzoo' },
    ],
  },
  {
    text: 'Console Metrics',
    value: 'Console Metrics',
    disabled: false,
    isNoIcon: true,
    children: [
      { text: 'Console Digital Revenue', value: 'console_digitalRevenue', icon: 'Mscience' },
      { text: 'Console Physical Revenue', value: 'console_physicalRevenue', icon: 'npd' },
      { text: 'Console MAU', value: 'console_mau', icon: 'newzoo' },
    ],
  },
  {
    text: 'Games Owned',
    value: 'gameOwned',
    disabled: false,
    isNoIcon: true,
    children: [],
  },
];
